import { RTKQueryTag } from 'src/common/constants';
import type { ApiResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';
import type { GetPurchaseWithLatestAttemptResponse } from './certification-details.types';

interface GetCertificationDetailsParams {
  userId: string;
  purchaseId: string;
}

export const certificationDetailsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCertificationDetails: builder.query<
      ApiResponse<GetPurchaseWithLatestAttemptResponse>,
      GetCertificationDetailsParams
    >({
      query: ({ userId, purchaseId }) => ({
        url: '/admin/users/certifications/latest-attempt',
        method: 'GET',
        params: { userId, purchaseId },
      }),
      providesTags: (result) =>
        result?.data?.purchase?._id ? [{ type: RTKQueryTag.CertificationExams, id: result.data.purchase._id }] : [],
    }),
    resetOnfido: builder.mutation<ApiResponse<null>, { certificationId: string }>({
      query: ({ certificationId }) => ({
        url: '/admin/users/certifications/reset-onfido',
        method: 'POST',
        params: { certificationId },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetCertificationDetailsQuery, useLazyGetCertificationDetailsQuery, useResetOnfidoMutation } =
  certificationDetailsApiSlice;
